import React from 'react';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons';
import { Button, Dialog } from 'src/components';

interface StrategyDeleteModalProps {
  open: boolean;
  onClose: () => void;
  onDelete: (id: string) => void;
  strategy: MedScout.Strategy | null;
}

const StrategyDeleteModal: React.FC<StrategyDeleteModalProps> = ({
  open,
  onClose,
  onDelete,
  strategy,
}) => {
  return (
    <Dialog isOpen={open} onClose={onClose} showCloseButton data-testid="strategy-delete-modal-dialog">
      <div className="px-6 py-4">
        <div className="flex flex-col items-center text-center space-y-4">
          <div className="w-16 h-16 rounded-full bg-red-50 flex items-center justify-center ring-8 ring-red-50/30" data-testid="strategy-delete-modal-icon-container">
            <Icon
              icon={faExclamationTriangle}
              className="text-red-600 text-2xl"
            />
          </div>

          <div className="space-y-2">
            <h3 className="text-lg font-semibold text-gray-900" data-testid="strategy-delete-modal-title">
              Delete strategy?
            </h3>
            <p className="text-sm text-gray-600 max-w-sm" data-testid="strategy-delete-modal-message">
              You&apos;re about to permanently delete{' '}
              <span className="font-medium text-gray-900" data-testid="strategy-delete-modal-strategy-name">
                &ldquo;{strategy?.label}&rdquo;
              </span>
              . This action cannot be undone.
            </p>
          </div>

          <div className="flex gap-3 pt-2 w-full">
            <Button
              variant="outlined"
              color="neutral"
              onClick={onClose}
              className="flex-1 hover:bg-gray-50 transition-colors"
              data-testid="strategy-delete-modal-cancel-button"
            >
              Cancel
            </Button>
            <Button
              variant="solid"
              color="danger"
              onClick={() => strategy && onDelete(strategy.id?.toString())}
              className="flex-1 hover:bg-red-700 transition-all hover:shadow-lg"
              data-testid="strategy-delete-modal-delete-button"
            >
              Delete
            </Button>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default StrategyDeleteModal;
